<app-folder-editform *ngIf="folder" [editedFolder]="folder">
</app-folder-editform>
